import type { InferRequestType, InferResponseType } from 'hono/client';
import { client } from '@/utils/client';
export type LoginReq = InferRequestType<typeof client.api.common.user.login.$post>['json'];
export type LoginRes = NonNullable<InferResponseType<typeof client.api.common.user.login.$post, 200>['data']>;
export type AssignRolesReq = InferRequestType<(typeof client.api.common.user)['assign-roles']['$post']>['json'];
export type GetListReq = InferRequestType<typeof client.api.common.user.$get>['query'];
export type GetListRes = NonNullable<InferResponseType<typeof client.api.common.user.$get, 200>['data']>;
export type GetListItem = NonNullable<GetListRes['items']>[number];
export type GetDetailRes = NonNullable<InferResponseType<(typeof client.api.common.user)[':id']['$get'], 200>['data']>;
export type CreateReq = InferRequestType<typeof client.api.common.user.$post>['json'];
export type CreateRes = NonNullable<InferResponseType<typeof client.api.common.user.$post, 200>['data']>;
export type UpdateReq = InferRequestType<(typeof client.api.common.user)[':id']['$put']>['json'];
export const login = async (data: LoginReq): Promise<LoginRes> => {
  const res = await client.api.common.user.login.$post({ json: data });
  return (await res.json()).data as LoginRes;
};
export const assignRoles = async (data: AssignRolesReq): Promise<void> => {
  await client.api.common.user['assign-roles'].$post({ json: data });
};
export const getList = async (params?: GetListReq): Promise<GetListRes> => {
  const res = await client.api.common.user.$get({ query: params || {} });
  return (await res.json()).data as GetListRes;
};
export const getDetail = async (id?: number): Promise<GetDetailRes> => {
  if (id === undefined) {
    const res = await client.api.common.user.detail.$get();
    return (await res.json()).data as GetDetailRes;
  }
  const res = await client.api.common.user[':id'].$get({ param: { id: String(id) } });
  return (await res.json()).data as GetDetailRes;
};
export const create = async (data: CreateReq): Promise<CreateRes> => {
  const res = await client.api.common.user.$post({ json: data });
  return (await res.json()).data as CreateRes;
};
export const update = async (id: number, data: UpdateReq): Promise<void> => {
  await client.api.common.user[':id'].$put({ param: { id: String(id) }, json: data });
};
const deleteRecord = async (id: number): Promise<void> => {
  await client.api.common.user[':id'].$delete({ param: { id: String(id) } });
};
export { deleteRecord as delete };
